'use client';
import AppLayout from '@/components/AppLayout';
import HelpCenterContent from './components/HelpCenterContent';

export default function HelpCenterPage() {
  return (
    <AppLayout>
      <HelpCenterContent />
    </AppLayout>
  );
}
